// import React from "react";

// const team = [
//   { name: "Geetanjali Anil Valmiki", role: "CEO", img: "/teams/1.jpeg" },
//   { name: "Valmiki A J", role: "Managing Director", img: "/teams/2.jpeg" },
//   // { name: "Pravin Kamble", role: "Director", img: "/teams/3.jpeg" },
//   // { name: "Apurva Rathod", role: "Administrator", img: "/teams/4.jpeg" },
//   // { name: "Prakash Kadam", role: "Material supplier", img: "/teams/5.jpeg" },
//   // { name: "Komal Wavare", role: "Office assistant", img: "/teams/6.jpeg" },
// ];

// export default function Management() {
//   return (
//     <section className="py-12 bg-gray-50">
//       <div className="max-w-7xl mx-auto px-4">

//         {/* Title */}
//         <h2 className="text-2xl sm:text-3xl font-bold text-center mb-10 text-blue-900">
//           Our Leadership Team
//         </h2>

//         {/* Grid */}
//         <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-6">
//           {team.map((member, index) => (
//             <div
//               key={index}
//               className="bg-white rounded-2xl shadow-md hover:shadow-xl transition p-4 text-center"
//             >
//               {/* Image */}
//               <img
//                 src={member.img}
//                 alt={member.name}
//                 className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 mx-auto rounded-xl object-cover border-4 border-indigo-500"
//               />

//               {/* Name */}
//               <h3 className="mt-4 text-sm sm:text-lg md:text-xl font-semibold text-gray-800">
//                 {member.name}
//               </h3>

//               {/* Role */}
//               <p className="text-indigo-600 font-medium text-xs sm:text-sm md:text-base mt-1">
//                 {member.role}
//               </p>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }



// import React from "react";

// const team = [
//   { name: "Geetanjali Anil Valmiki", role: "CEO", img: "/teams/1.jpeg" },
//   { name: "Valmiki A J", role: "Managing Director", img: "/teams/2.jpeg" },
// ];

// export default function Management() {
//   return (
//     <section className="py-16 bg-gray-100">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

//         <h2 className="text-3xl sm:text-4xl font-bold text-center text-blue-900 mb-12">
//           Our Leadership Team
//         </h2>

//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
//           {team.map((member, index) => (
//             <div
//               key={index}
//               className="bg-gray-100 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 text-center"
//             >
              
//               {/* Square Image */}
//               <div className="w-32 h-32 sm:w-36 sm:h-36 md:w-40 md:h-40 mx-auto overflow-hidden rounded-xl border-4 border-indigo-500 bg-white">
//   <img
//     src={member.img}
//     alt={member.name}
//     className="w-full h-full object-contain bg-slate-300"
//   />
// </div>


//               <h3 className="mt-5 text-lg sm:text-xl font-semibold text-gray-800">
//                 {member.name}
//               </h3>

//               <p className="text-indigo-600 font-medium text-sm sm:text-base mt-1">
//                 {member.role}
//               </p>

//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }


import React from "react";

const team = [
  { name: "Geetanjali Anil Valmiki", role: "CEO", img: "/teams/1.jpeg" },
  { name: "Valmiki A J", role: "Managing Director", img: "/teams/2.jpeg" },
];

export default function Management() {
  return (
    <section className="py-16 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <h2 className="text-3xl sm:text-4xl font-bold text-center text-blue-900 mb-12">
          Our Leadership Team
        </h2>

        {/* Flex container for centering */}
        <div className="flex flex-wrap justify-center gap-8">
          {team.map((member, index) => (
            <div
              key={index}
              className="bg-gray-100 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 text-center w-72 sm:w-80"
            >
              {/* Image */}
              <div className="w-32 h-32 sm:w-36 sm:h-36 md:w-40 md:h-40 mx-auto overflow-hidden rounded-xl border-4 border-indigo-500 bg-white">
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-full h-full object-contain bg-slate-300"
                />
              </div>

              {/* Name */}
              <h3 className="mt-5 text-lg sm:text-xl font-semibold text-gray-800">
                {member.name}
              </h3>

              {/* Role */}
              <p className="text-indigo-600 font-medium text-sm sm:text-base mt-1">
                {member.role}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}